export const USA_CONFIGURATION = 'usa_configuration'
export const CANADA_CONFIGURATION = 'canada_configuration'
export const EUROPE_CONFIGURATION = 'europe_configuration'
export const ITALY_CONFIGURATION = 'italy_configuration'
export const OTHERS_EUROPE_CONFIGURATION = 'others_europe_configuration'
export const BRAZIL_CONFIGURATION = 'brazil_configuration'
export const MEXICO_CONFIGURATION = 'mexico_configuration'
export const AUSTRALIA_CONFIGURATION = 'australia_configuration'
